<template>
  <div v-if="show" class="modal-overlay" @click.self="handleClose">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Error</h2>
        <button @click="handleClose" class="close-button" aria-label="Close">×</button>
      </div>

      <div class="modal-body">
        <div class="error-icon" aria-hidden="true">⚠️</div>
        <div class="error-messages">
          <p v-for="(message, index) in messages" :key="index" class="error-message">
            {{ message }}
          </p>
        </div>
        <button @click="handleClose" class="close-action-button">
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    messages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        // Prevent body scroll when modal is open
        document.body.style.overflow = 'hidden'
      } else {
        // Restore body scroll when modal closes
        document.body.style.overflow = ''
      }
    }
  },
  beforeUnmount() {
    // Ensure body scroll is restored if component is destroyed
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: var(--color-surface-light);
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.2s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  border-bottom: 2px solid var(--color-border-light);
}

.modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: var(--color-error-dark);
  font-weight: 600;
}

.close-button {
  background: none;
  border: none;
  font-size: 2rem;
  color: var(--color-text-secondary);
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all var(--transition-normal);
}

.close-button:hover {
  background-color: var(--color-surface-dark);
  color: var(--color-text-primary);
}

.modal-body {
  padding: 30px;
  text-align: center;
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 20px;
}

.error-messages {
  margin-bottom: 30px;
}

.error-message {
  color: var(--color-text-primary);
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 12px 0;
  padding: 12px;
  background-color: var(--color-error-light);
  border-left: 4px solid var(--color-error-main);
  border-radius: 4px;
  text-align: left;
}

.error-message:last-child {
  margin-bottom: 0;
}

.close-action-button {
  width: 100%;
  padding: 14px 20px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-normal);
  background-color: var(--color-primary-main);
  color: var(--color-text-inverse);
}

.close-action-button:hover {
  background-color: var(--color-primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(212, 165, 169, 0.3);
}

.close-action-button:active {
  transform: translateY(0);
}
</style>

